<template>
  <InputBox
    class="text-input"
    :icon="icon"
    :required="required"
    :error="error"
    :resizable="type === 'textarea'"
  >
    <component
      :is="type === 'textarea' ? 'textarea' : 'input'"
      :type="type"
      class="text-input__input"
      :class="`text-input__input_type_${type}`"
      v-bind="inputAttrs"
      :value="model"
      @input="onInput"
    />
  </InputBox>
</template>

<script setup lang="ts">
import type {InputHTMLAttributes} from "vue";
import type {InputBoxProps} from "@website/components/inputs/InputBox.vue";

const attrs = useAttrs();

export interface TextFieldProps extends /* @vue-ignore */ Omit<InputHTMLAttributes, 'required'>, InputBoxProps {
  type?: 'text' | 'password' | 'textarea',
}

const props = withDefaults(defineProps<TextFieldProps>(), {
  required: false,
});

const inputAttrs = computed(() => {
  const returnObj: any = {}
  for (const attr in attrs) {
    if (attr !== 'class' && attr !== 'value') {
      returnObj[attr] = attrs[attr]
    }
  }
  return returnObj;
})

const model = defineModel<string | null>({default: null, required: true,})

async function onInput(event: Event) {
  const target = event.target as HTMLInputElement | null
  model.value = target?.value || null;
}
</script>

<style lang="scss">
.text-input {
  &__input {
    background: none;
    outline: none;
    border: none;

    width: 100%;
    height: 100%;

    resize: none;

    &, &::placeholder {
      color: #212529;
      font-family: var(--font-family-main);
      font-size: 18px;
      font-weight: 500;
    }
  }
}
</style>